export const rightHandFingeringMapping = {
    // 单指法映射: 指法 -> { 方向: 内/外, 手指 }
    "勾": { direction: "in", finger: "三" },
    "抹": { direction: "in", finger: "二" },
    "挑": { direction: "out", finger: "二" },
    "剔": { direction: "out", finger: "三" },
    "打": { direction: "in", finger: "四" },
    "摘": { direction: "out", finger: "四" },
    "托": { direction: "out", finger: "一" },
    "劈": { direction: "in", finger: "一" },
};

export const leftHandFingeringMapping = {
    // 左手指法映射: 技法 -> { SVG 名称, 位置, 说明 }
    "注": { svgName: "slidedown", position: "in", description: "下滑音" },
    "吟": { svgName: "vibration", position: "up", description: "揉弦" },
    "猱": { svgName: "vibration", position: "up", description: "揉弦" },
    "绰": { svgName: "slideup", position: "in", description: "上滑音" },
    "撞": { svgName: "updown", position: "in", description: "快速上下拨" },
    "爪起": { svgName: "arrowup", position: "in", description: "爪起" },
    "带起": { svgName: "arrowup", position: "in", description: "带起" },
    "韬起": { svgName: "arrowup", position: "in", description: "掏起" },
    "放合": { svgName: "arrowup", position: "in", description: "放合" },
};

export const complexFingeringMapping = {
    "撮": {
        parts: 2,
        directions: ["out", "in"],
        finger: ['', ''],
    },
    "拨": { parts: 2, directions: ["in", "in"], finger: ['', ''], },
    "刺": { parts: 2, directions: ["out", "out"], finger: ['', ''], },
    "历": {
        parts: 2,
        directions: ["in", "in"],
        splitDuration: true, // 时值分成两部分
        finger: ['', ''],
    },
    "如一": { parts: 2, directions: ["in", "in"], finger: ['', ''], addString: true },
};
